import footer from './modules/footer.json';
import tournament from './modules/tournament.json';
import teams from './modules/teams.json';
import errors from './modules/errors.json';
import team from './modules/team.json';
import common from './modules/common.json';
import contentPage from './modules/contentPage.json';

export const ru = {
  translation: {
    footer,
    tournament,
    teams,
    errors,
    team,
    common,
    contentPage,

    // Forgive me Gods
    "Incorrect password": "Неверный пароль",
  }
};
